import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, linkText } from '../../../helpers/getEmailStyles';

class BookingConfirmationGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			guestName: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			listCity: PropTypes.string.isRequired,
			threadId: PropTypes.number.isRequired,
		}).isRequired
	};

	render() {
		const { content: { guestName, listTitle, listCity, threadId, logo, siteName, checkIn, checkOut } } = this.props;
		let contactURL, checkInDate, checkOutDate
		contactURL = url + '/message/' + threadId + '/guest';
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : ''
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''
		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<EmptySpace height={20} />
					<div style={fontWeightBold}>
						Hi {guestName},
					</div>
					<EmptySpace height={20} />
					<div>
						Thank you for choosing {siteName} for your stay in {listCity}! We’re excited to confirm your reservation at {listTitle} from {checkInDate} to {checkOutDate}.
					</div>
					<EmptySpace height={20} />
					<div>
						We hope you have a fantastic experience! If you need anything, feel free to reach out to your host.
					</div>
					<div>
						<a style={linkText} href={contactURL}>contact host</a>
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingConfirmationGuest;